import { consoleApi } from '@nx/state';
import { isNotNullish, isNullish } from '@nx/stdlib';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

import { clearGlQueryParam, extractGaClientId } from './helpers';

export const useHandleGaQueryParam = () => {
  const { data: user } = consoleApi.useGetUserDetailsQuery();
  const [searchParams] = useSearchParams();
  const gl = searchParams.get('_gl');
  const [setUserTrackingId] = consoleApi.useSetUserTrackingIdMutation();

  useEffect(() => {
    if (isNullish(gl) || isNullish(user)) {
      return;
    }

    if (isNotNullish(user.trackingId)) {
      clearGlQueryParam();
      return;
    }

    const gaClientId = extractGaClientId(gl);

    if (isNotNullish(gaClientId)) {
      void setUserTrackingId({ userId: user.id, trackingId: gaClientId });
    }

    clearGlQueryParam();
  }, [gl, user, setUserTrackingId]);
};
